import { getTemplatesMetaTranslations } from "./modules/templatesMeta";
import { getOperationsTranslations } from "./modules/operations";
import { getMarketingTranslations } from "./modules/marketing";
import { getAutomationTranslations } from "./modules/automation";
import { getAnalyticsTranslations } from "./modules/analytics";
import { getPublicAccessTranslations } from "./modules/publicAccess";

const messages = {
  es: {
    translations: {
      publicAccess: getPublicAccessTranslations("es"),
      settingsSuite: {
        common: { updating: "ACTUALIZANDO...", enabled: "✓ HABILITADO", disabled: "✕ DESHABILITADO", saving: "GUARDANDO...", save: "GUARDAR", sending: "ENVIANDO...", sendTest: "ENVIAR PRUEBA", generating: "Generando...", restoring: "Restaurando..." },
        page: { schedulesSuccess: "Horarios actualizados correctamente.", serviceCompletion: "Finalización de la atención", whitelabel: "Marca blanca" },
        branding: { section: "Pantalla de inicio de sesión / Marca", title: "Personalice la experiencia de su marca", help: "Configure el banner, el logo, los enlaces y los textos del inicio de sesión sin cambiar código ni generar una nueva compilación.", smtp: "Correo electrónico (SMTP)", port: "Puerto", secure: "Seguro (SSL/TLS)", secureHelp: 'Use "true" para una conexión segura y "false" para STARTTLS/normal.', appPassword: "Contraseña de aplicación", sender: "Remitente (FROM)", senderExample: "Ejemplo: Su empresa <soporte@gmail.com>", testEmail: "Correo de prueba", testEmailHelp: "Si se deja vacío, se usará el correo indicado arriba.", whatsappLogin: "Mostrar el botón de WhatsApp en el inicio de sesión", bannerMode: "Modo del banner", imageUrl: "URL de la imagen", internalUpload: "Carga / imagen interna", whatsappNumber: "Número de WhatsApp en el inicio de sesión", loginLogo: "Logo de la pantalla de inicio de sesión", logoUrl: "URL del logo de inicio de sesión", logoUpload: "Carga del logo", sendLogo: "Subir logo", removeUpload: "Eliminar carga", logoPriority: "El archivo cargado tiene prioridad sobre la URL del logo.", logoPreview: "Vista previa del logo", noLogo: "No hay ningún logo configurado", loginBanner: "Banner de la pantalla de inicio de sesión", bannerUrl: "URL de la imagen del banner", bannerUpload: "Carga del banner", sendBanner: "Subir banner", bannerInternalHelp: "Cuando se seleccione el modo carga/imagen interna, el sistema usará este archivo.", bannerPreview: "Vista previa del banner", noBanner: "No hay ningún banner configurado", bannerTitle: "Título del banner", bannerSubtitle: "Subtítulo del banner" },
        meta: { section: "Integración con Meta / Facebook / Instagram", title: "Configure la conexión de Meta directamente en el sistema", help: "Estos datos se usan en la pantalla de conexiones para iniciar sesión con Facebook e Instagram, sin depender de .env ni generar una nueva compilación.", appIdHelp: "Introduzca el App ID de su aplicación en Meta", appSecretHelp: "Introduzca el App Secret de su aplicación en Meta", embeddedSignupConfigId: "ID de configuración del registro insertado (opcional)", embeddedSignupConfigIdHelp: "Necesario únicamente para usar el botón Conectar con Coexistencia.", sdkVersion: "Versión del SDK de Meta", permission: "Exigir el permiso business_management" },
        options: { general: "Configuraciones generales", currency: "Moneda de la empresa", currencyHelp: "Se utiliza en ventas, Kanban, informes y valores financieros.", currencyUpdated: "¡Moneda actualizada correctamente!", supportNumber: "Número de soporte", supportHelp: "Número con código de país, usado en el botón Llamar a soporte.", aiSection: "IA — Sugerencias de respuestas", enableSuggestions: "Activar sugerencias de respuestas", openAiKey: "Clave de API de OpenAI", aiModel: "Modelo de IA", analyzedMessages: "Cantidad de mensajes analizados", aiPrompt: "Prompt de la IA", scheduleBot: "Programación y bot", companyRegistration: "Registro de empresas", requireDocument: "Exigir documento fiscal en el registro", push: "Notificaciones push", pushEnabled: "Push activado", pushHelp: "Active las notificaciones push en este navegador para recibir nuevos mensajes.", copyPrefix: "Configuración del prefijo para copiar contactos", efi: "Configuración Pix Efí (GerenciaNet)", sendCertificate: "Subir certificado .P12 de Efí", noCertificate: "No se ha subido ningún certificado", certificatePassword: "Contraseña del certificado de Efí" },
        backup: { sqlSuccess: "¡Backup SQL descargado correctamente!", sqlError: "Error al generar el backup SQL.", jsonSuccess: "¡Backup JSON descargado correctamente!", jsonError: "Error al generar el backup JSON.", sqlOnly: "Solo se aceptan archivos .sql para restaurar.", confirm: "ATENCIÓN: la restauración sobrescribirá los datos actuales de la base. ¿Está seguro de continuar? Recomendamos hacer un backup antes.", restoreSuccess: "¡Base de datos restaurada correctamente! Recargue la página.", restoreError: "Error al restaurar la base de datos.", title: "Backup de la base de datos", description: "Descargue una copia completa de la base de datos en el formato deseado.", sql: "Backup SQL (.sql)", json: "Backup JSON (.json)", tip: "El backup SQL es ideal para una restauración completa. El backup JSON es útil para análisis y migración de datos.", restoreTitle: "Restaurar base de datos", danger: "Zona de peligro:", dangerHelp: "La restauración sobrescribirá todos los datos actuales. Asegúrese de tener un backup actualizado antes de continuar.", upload: "Subir archivo .sql para restaurar", companyTitle: "Backup individual por empresa", companyDescription: "Exporte solo los datos de la empresa seleccionada, incluidos sus vínculos relacionales.", selectCompany: "Seleccionar empresa", companySQL: "Empresa en SQL", companyJSON: "Empresa en JSON", companySuccess: "¡Backup de la empresa descargado correctamente!", companyError: "Error al generar el backup de la empresa.", companyListError: "Error al cargar las empresas.", selectCompanyError: "Seleccione una empresa." }
        ,completion: { title: "Finalización de la atención", saleValue: "Solicitar el valor de la venta al finalizar la atención", saleValueHelp: "Cuando esté habilitado, el campo del valor de venta aparecerá en el diálogo de finalización.", reasons: "Motivos de finalización", addReason: "Agregar motivo", noReasons: "No hay motivos registrados. Haga clic en Agregar motivo para comenzar.", reasonName: "Nombre del motivo", description: "Descripción (opcional)", nameRequired: "El nombre del motivo es obligatorio.", updated: "¡Motivo actualizado correctamente!", created: "¡Motivo creado correctamente!", deleted: "¡Motivo eliminado correctamente!", configUpdated: "¡Configuración actualizada correctamente!", configError: "Error al actualizar la configuración." }
        ,certificate: { noPermission: "¡No tiene permiso para acceder!", p12Only: "¡Use únicamente archivos con formato .p12!", chooseFile: "¡Seleccione un archivo!", chooseDestination: "¡Seleccione un destino!", sent: "¡Archivo subido correctamente!", title: "Certificado Efí — API Pix (.p12)", chooseOption: "Seleccione una opción:", option: "Certificado Efí .p12 de la API Pix", send: "SUBIR CERTIFICADO" }
        ,paymentGuide: { title: "Integración con Mercado Pago", intro: "Siga estos pasos para integrar su sistema con Mercado Pago:", account: "Cree una cuenta en Mercado Pago Developers.", application: "Cree una aplicación en Mercado Pago Developers.", production: "Acceda a Producción y Credenciales de producción.", copyKey: "Copie la credencial y péguela en el campo Access Token.", notifications: "En Mercado Pago, acceda a Notificaciones y Webhooks.", webhook: "En modo Producción, introduzca la URL mostrada y marque Pagos en Eventos." }
        ,aiHelp: { apiKeySaved: "Su clave de OpenAI se guardará en la base de datos.", modelExample: "Ejemplo: gpt-4o-mini", recommendedRange: "Recomendado: de 10 a 20 mensajes", promptHelp: "Defina cómo debe responder la IA." }
      },
      connectionSuite: {
        common: { yes: "Sí", no: "No", cancel: "Cancelar", close: "Cerrar", save: "Guardar", confirm: "Confirmar", loading: "Cargando...", error: "Error", status: "Estado", details: "Detalles", createdAt: "Creado el", updatedAt: "Actualizado el", requiredPhone: "Introduzca el número de teléfono.", brazilFormat: "Para números de Brasil, use 55 + código de área + número.", pairingCodeMissing: "El servidor no devolvió el código de vinculación.", digitsHelp: "dígitos — código de país + código de área + número", waitingCode: "Esperando el código...", enterCodeNow: "Introduzca el código en WhatsApp", codeExpiring: "¡El código está por caducar!", generateCode: "Generar código", activationHistory: "Historial de activación de la API Oficial", connection: "Conexión", stepType: "Tipo de conexión", stepMeta: "Conectar con Meta", stepFinish: "Finalizar", processing: "Procesando...", waitingMeta: "Esperando a Meta...", finishOnboarding: "Completar onboarding" },
        list: { transferProgress: "Transfiriendo tickets", tickets: "tickets", transferWait: "Espere mientras se transfieren los tickets...", beforeDelete: "Antes de eliminar", beforeDeleteHelp: "¿Ya transfirió los tickets de esta conexión a otra? Si no, recomendamos transferirlos antes de eliminarla.", notYet: "Todavía no", whatsappOfficial: "WhatsApp Oficial", diagnosticsTooltip: "Diagnóstico de la conexión", logsTooltip: "Registros del onboarding", syncTemplatesTooltip: "Sincronizar plantillas", copyWebhookTooltip: "Copiar webhook", selectConnections: "Seleccione las conexiones de origen y destino.", differentConnections: "Las conexiones de origen y destino deben ser diferentes.", metaLoginCancelled: "El inicio de sesión de Meta no se completó.", metaAppIdMissing: "Configure el App ID de Meta en los ajustes del sistema.", metaSettingsLoading: "Cargando la configuración de Meta. Espere un momento.", metaStarting: "La integración de Meta todavía se está iniciando. Inténtelo de nuevo en 2 segundos.", metaSdkLoading: "El SDK de Meta todavía se está cargando. Inténtelo de nuevo en unos segundos.", metaSdkUnavailable: "El SDK de Facebook no está disponible. Recargue la página." },
        modal: { connectionNameRequired: "Introduzca el nombre de la conexión.", telegramCredentialsRequired: "Introduzca el API ID, el API Hash y el teléfono.", telegramCodeSent: "Código enviado por Telegram. Revise la aplicación Telegram.", sendCodeFirst: "Envíe primero el código.", telegramCodeRequired: "Introduzca el código recibido en Telegram.", twoFactorRequired: "La contraseña de autenticación en dos pasos es obligatoria. Introdúzcala y confirme de nuevo.", sessionDisconnected: "Sesión desconectada correctamente. Espere unos segundos y vuelva a generar el código QR en la misma conexión.", saveChangesFirst: "Haga clic en Guardar para registrar los cambios.", officialOnboarding: "Onboarding de autoservicio de la API Oficial", officialOnboardingHelp: "Conecte la API Oficial mediante el Registro Integrado de Meta y, cuando sea elegible, use la coexistencia con el número existente de WhatsApp Business.", onboardingStatus: "Estado del onboarding", connectionHealth: "Salud de la conexión", signedWebhook: "Webhook suscrito", displayedNumber: "Número mostrado", verifiedName: "Nombre verificado", lastError: "Último error", connectMeta: "Conectar con Meta", welcomeFlow: "Flujo de bienvenida", welcomeFlowHelp: "Este flujo se activa solo para contactos nuevos: personas que no están en su lista de contactos y que enviaron un mensaje.", defaultResponseFlow: "Flujo de respuesta predeterminado", defaultResponseFlowHelp: "La respuesta predeterminada se envía cuando el mensaje no coincide con una palabra clave. Atención: se activará si la atención ya está cerrada." },
        diagnostics: { title: "Diagnóstico de la API Oficial", help: "Valida el token, el número, la suscripción de la aplicación y el webhook, y permite reconectar o probar el envío.", reconnectSuccess: "Reconexión solicitada correctamente.", testNumberRequired: "Introduzca el número de prueba.", textSuccess: "Mensaje de texto de prueba enviado correctamente.", templateNameRequired: "Introduzca el nombre de la plantilla.", templateSuccess: "Mensaje de plantilla de prueba enviado correctamente.", tokenPresent: "Token presente", tokenValid: "Token válido", wabaPresent: "ID de WABA presente", phoneIdPresent: "ID del número de teléfono presente", numberAccessible: "Número accesible", appSubscribed: "Aplicación suscrita a WABA", finalStatus: "Estado final", textTest: "Prueba con texto", textTestHelp: "Úselo cuando haya una ventana de 24 horas abierta con el contacto.", testMessage: "Mensaje de prueba", templateTest: "Prueba con plantilla", templateTestHelp: "Úselo fuera de la ventana de 24 horas con una plantilla aprobada por Meta.", templateName: "Nombre de la plantilla", templateLanguage: "Idioma de la plantilla", templateParameters: "Parámetros de la plantilla", parametersHelp: "Separe los parámetros con comas, en el mismo orden de la plantilla.", update: "Actualizar diagnóstico", reconnect: "Reconectar" },
        embedded: { title: "Onboarding de autoservicio de la API Oficial", chooseType: "Elija el tipo de conexión", newNumber: "Nuevo número / nueva conexión de API Oficial", newNumberHelp: "Ideal para activar un número nuevo directamente mediante el flujo de Meta.", currentNumber: "Usar mi número actual de WhatsApp Business", currentNumberHelp: "Flujo de coexistencia para cuentas elegibles de la aplicación WhatsApp Business.", connectionName: "Nombre de la conexión", finalTestNumber: "Número para la prueba final", selectedMode: "Modo seleccionado", continueHelp: "Al continuar, el sistema abrirá el onboarding de Meta para autorizar y vincular el número y completar la conexión.", capturedData: "Datos del onboarding capturados", returnedCode: "Código devuelto por Meta", nextStep: "Siguiente paso", nextStepHelp: "El backend cambiará el código por un token, sincronizará los datos de WABA, suscribirá el webhook, validará la conexión e intentará enviar el mensaje de prueba.", connectionId: "ID de la conexión", diagnostic: "Diagnóstico", capturedSuccess: "Respuesta de Meta capturada correctamente.", incompleteData: "Los datos del Registro Integrado están incompletos.", completed: "Onboarding de la API Oficial completado correctamente.", createdSuccess: "Conexión creada correctamente", createdPending: "Conexión creada con elementos pendientes" },
        logs: { title: "Registros del onboarding oficial", empty: "No se encontraron registros para esta conexión.", error: "Error", payload: "Datos" },
        pairing: { title: "Conectar mediante código de vinculación", enterNumber: "Introduzca el número de WhatsApp con", countryCode: "código de país + código de área", example: "Ejemplo", whatsappNumber: "Número de WhatsApp", tooShort: "El número es demasiado corto. Incluya el código de país y el código de área.", tooLong: "El número es demasiado largo.", connected: "¡Conectado!", connectedHelp: "WhatsApp se vinculó correctamente. Esta ventana se cerrará automáticamente.", instructions: "En WhatsApp, vaya a:", path: "Configuración → Dispositivos vinculados → Vincular un dispositivo", tap: "Toque", phoneLink: "Vincular con número de teléfono", enterCode: "e introduzca el código exactamente como aparece (sin espacios):", waiting: "Esperando que introduzca el código en WhatsApp...", syncing: "Sincronizando la sesión... ¡Casi listo!", tryAgain: "Intentar de nuevo", success: "¡WhatsApp conectado correctamente!", failed: "La vinculación falló. Inténtelo de nuevo.", alreadyConnected: "¡WhatsApp ya está conectado!", generated: "¡Código generado! Introdúzcalo en WhatsApp en un máximo de 60 segundos." }
      },
      finalTouches: {
        common: { remove: "Eliminar", online: "En línea", offline: "Desconectado" },
        ai: {
          title: "Agente Comercial de IA", newAgent: "Nuevo agente", newTitle: "Nuevo Agente Comercial de IA", editTitle: "Editar Agente Comercial de IA",
          pageHelp: "Configure agentes comerciales para responder clientes potenciales automáticamente, calificar oportunidades, aplicar etiquetas, generar resúmenes internos y transferir a atención humana.", modalHelp: "Configure el agente para calificar clientes potenciales, aplicar etiquetas, generar un resumen interno y transferir a atención humana cuando sea necesario.", onlyPending: "Solo en espera", allConnections: "Todas", transferQueue: "Cola de transferencia", validConfig: "Configuración válida", interactions: "Interacciones", empty: "No se encontró ninguna configuración.", removeTitle: "¿Eliminar configuración?", removeNamed: "¿Eliminar la configuración {{name}}?", removeHelp: "Esta acción no elimina sesiones ya registradas, solo la configuración del agente."
        },
        warmup: {
          title: "Calentamiento de Chips", subtitle: "Conexiones aisladas para calentamiento, separadas de las conexiones estándar del sistema.", unavailableTitle: "Calentamiento de Chips no disponible", unavailableHelp: "Su plan actual no incluye acceso a esta función.", waitingQr: "Esperando QR", minDelayError: "El retraso mínimo debe ser mayor que 1000 ms.", maxDelayError: "El retraso máximo debe ser mayor o igual al mínimo.", saved: "¡Configuración guardada correctamente!", statusTitle: "Estado del calentamiento", cluster: "Clúster", running: "en ejecución", stopped: "detenido", onlineConnections: "Conexiones en línea", active: "Calentamiento activo", paused: "Calentamiento pausado", configuration: "Configuración", minDelay: "Retraso mínimo (ms)", maxDelay: "Retraso máximo (ms)", messagesPerCycle: "Mensajes por ciclo", prompt: "Frases alternadas / prompt", promptHelp: "Introduzca una frase por línea. El sistema las seleccionará y alternará automáticamente.", saveConfig: "Guardar configuración", newConnection: "Nueva conexión", group: "Grupo", createQr: "Crear conexión / generar QR", connectionsTitle: "Conexiones de calentamiento", noNumber: "No se informó ningún número", session: "Sesión", reconnect: "Generar QR / Reconectar", empty: "No hay conexiones de calentamiento registradas.", scanQr: "Escanee el código QR"
        },
        financial: {
          subtitle: "Consulte sus facturas, vencimientos y pagos en un solo lugar.", subscriptionStatus: "Estado de la suscripción", active: "Activa", expired: "Vencida", currentDueDate: "Vencimiento actual", totalRegistered: "Total registrado", open: "Pendientes", awaitingPayment: "Esperando pago", processing: "Procesando", confirming: "Confirmación en curso", paidPlural: "Pagadas", alreadyConfirmed: "Ya confirmadas", organizedTitle: "Área financiera organizada", organizedHelp: "Consulte facturas, controle vencimientos y realice pagos con mayor claridad.", expiredTitle: "Su suscripción está vencida", expiredHelp: "Regularice el pago para mantener el sistema en pleno funcionamiento.", processingTitle: "Pago en procesamiento", processingHelp: "Identificamos un pago reciente de su suscripción. Tras la confirmación del proveedor, la actualización puede tardar entre 5 y 10 minutos.", pendingHelp: "Si ya completó el pago, la confirmación puede tardar entre 5 y 10 minutos. Esta página se actualizará automáticamente.", whatNow: "¿Qué sucede ahora?", autoUpdateHelp: "Una vez confirmada la operación, la página se actualizará automáticamente. Puede permanecer aquí y seguir el estado.", invoice: "Factura", value: "Valor", waitingTime: "Tiempo de espera", minutes: "{{count}} minuto(s)", updateNow: "Actualizar ahora", viewProcessing: "Ver pago en procesamiento", notPaidYet: "Aún no he pagado", success: "Pago confirmado correctamente. La suscripción fue actualizada.", paymentConfirmed: "Pago confirmado", dueToday: "Vence hoy", daysLeft: "Faltan {{count}} día(s)", daysOverdue: "Atrasada hace {{count}} día(s)", subscriptionInvoice: "Factura de suscripción", pay: "PAGAR", paid: "PAGADO", empty: "No se encontraron facturas", emptyHelp: "Los movimientos financieros aparecerán aquí cuando estén disponibles.", statuses: { open: "Pendiente", processing: "Procesando", overdue: "Vencida", paid: "Pagada" }
        },
        checkout: {
          subscriptionPayment: "Pago de la suscripción", subscriptionPaymentHelp: "Elija la forma de pago y complete su renovación de forma segura.", providerHelp: "Después de completar el pago, la confirmación puede tardar unos minutos en reflejarse en el sistema. La suscripción se actualizará automáticamente cuando el proveedor la confirme.", data: "Datos", customize: "Personalizar", review: "Revisar", finishRenewal: "Complete su renovación", finishRenewalHelp: "Genere su cobro de forma segura y siga la confirmación del pago en el sistema.", confirmedHelp: "Recibimos la confirmación del pago y la suscripción ya fue actualizada.", processingHelp: "Después de completar el pago, la confirmación puede tardar entre 5 y 10 minutos. La actualización se realizará automáticamente.", chargeCreated: "¡Cobro generado correctamente! Después del pago, la confirmación puede tardar entre 5 y 10 minutos.", back: "VOLVER", next: "SIGUIENTE", generatePayment: "GENERAR PAGO", month: "mes", select: "SELECCIONAR", subscriptionSummary: "Resumen de la suscripción", planDetails: "Detalles del plan", users: "Usuarios", connections: "Conexiones", queues: "Colas", billing: "Cobro", monthly: "Mensual", paymentInformation: "Información de pago", email: "Correo electrónico", name: "Nombre", taxId: "Documento fiscal", total: "Total", stepNotFound: "Paso no encontrado", invoiceNumber: "Factura #{{id}}", licenseRenewed: "¡Su licencia fue renovada hasta {{date}}!", copied: "Copiado", copyPix: "Copiar código QR PIX", pixHelp: "Para finalizar, pague escaneando o pegando el código PIX anterior, o elija pagar con tarjeta de crédito.", payCreditCard: "Pagar con Tarjeta de Crédito", payMercadoPago: "Pagar con MercadoPago", payAsaas: "Pagar con Asaas"
        }
      },
      adminOps: {
  "navigation": {
    "serverReport": "Informe del Servidor",
    "aiSalesAgent": "Agente IA Comercial"
  },
  "server": {
    "restricted": "Acceso restringido",
    "restrictedHelp": "El Informe del Servidor está disponible solo para el Super Admin.",
    "title": "Informe del Servidor",
    "subtitle": "Panel premium de salud del sistema: infraestructura, servicios, módulos comerciales, API Oficial, Wavoip, Landing Pages, Flowbuilder, Follow-up, Calentamiento de Chips e integraciones.",
    "loading": "Cargando información del sistema...",
    "refresh": "Actualizar",
    "online": "En línea",
    "available": "Disponible",
    "warning": "Atención",
    "critical": "Crítico",
    "offline": "Desconectado",
    "unknown": "Verificar",
    "noDetails": "Sin detalles adicionales",
    "memory": "Memoria RAM",
    "disk": "Disco",
    "cores": "{{count}} núcleos",
    "usedOf": "{{used}} GB usados de {{total}} GB",
    "environment": "Entorno",
    "product": "Producto",
    "module": "Módulo",
    "server": "Servidor",
    "system": "Sistema",
    "serverUptime": "Uptime del servidor",
    "backendUptime": "Uptime del backend",
    "updatedAt": "Actualizado el",
    "pm2Services": "Servicios PM2",
    "infrastructureTitle": "Infraestructura",
        "infrastructure": {
          "database": "Base de datos principal del sistema.",
          "redis": "Caché, colas, adaptador de sockets y recursos en tiempo real.",
          "nginx": "Proxy inverso y publicación HTTPS de los servicios.",
          "pm2": "Gestor de procesos Node.js."
        },
    "systemModules": "Módulos del sistema",
    "modulesHelp": "Recursos estratégicos disponibles en el sistema principal.",
    "overallHealthy": "Todos los indicadores principales funcionan con normalidad.",
    "memoryDetail": "memoria",
    "service": {
      "backend": {
        "name": "Backend del sistema",
        "description": "API principal, autenticación, tickets, mensajes e integraciones."
      },
      "frontend": {
        "name": "Frontend del sistema",
        "description": "Interfaz web del panel administrativo y atención."
      },
      "official": {
        "name": "API Oficial",
        "description": "Servicio dedicado para WhatsApp Cloud API / Meta."
      },
      "transcription": {
        "name": "Transcripción",
        "description": "Servicio auxiliar para transcripción y procesamiento de audio."
      }
    },
    "feature": {
      "followup": "Programaciones, recordatorios y continuidad comercial.",
      "official": "WhatsApp Oficial, plantillas, medios y ventana de atención.",
      "warmup": "Módulo para calentamiento y preparación de conexiones.",
      "email": "Configuraciones, eventos e infraestructura para enviar correos.",
      "wavoip": "Llamadas, historial y telefonía integrada.",
      "landing": "Captación de leads mediante formularios, WordPress y Elementor.",
      "flowbuilder": "Flujos, automatizaciones y campañas visuales.",
      "asaas": "Consulta de cobros y segunda copia de boletos.",
      "radar": "Análisis inteligente de conversaciones y sugerencias comerciales.",
      "campaigns": "Envíos, listas, informes y configuración de campañas.",
      "codeModule": "Módulo encontrado en el código",
      "configured": "Configurado en el entorno"
    },
    "featureName": {
      "followup": "Follow-up",
      "official": "API Oficial",
      "warmup": "Calentamiento de Chips",
      "email": "Email Marketing",
      "wavoip": "Wavoip",
      "landing": "Landing Pages",
      "flowbuilder": "Flowbuilder",
      "asaas": "Asaas / Boletos",
      "radar": "Radar de Oportunidades",
      "campaigns": "Campañas"
    }
  },
  "ai": {
    "title": "Agente IA Comercial",
    "newAgent": "Nuevo agente",
    "pageHelp": "Configure agentes comerciales para responder leads automáticamente, calificar oportunidades, aplicar etiquetas, generar resúmenes internos y transferir a atención humana.",
    "newTitle": "Nuevo Agente IA Comercial",
    "editTitle": "Editar Agente IA Comercial",
    "modalHelp": "Configure el agente para calificar leads, aplicar etiquetas, generar resúmenes internos y transferir a atención humana cuando sea necesario.",
    "name": "Nombre",
    "status": "Estado",
    "connection": "Conexión",
    "queue": "Cola",
    "agent": "Agente",
    "interactions": "Interacciones",
    "actions": "Acciones",
    "active": "Activo",
    "inactive": "Inactivo",
    "onlyWaiting": "Solo en espera",
    "all": "Todas",
    "transferQueue": "Cola de transferencia",
    "noQueue": "Sin cola",
    "notDefined": "No definido",
    "model": "Modelo IA",
    "temperature": "Temperatura",
    "maxInteractions": "Máximo de interacciones",
    "welcomeMessage": "Mensaje inicial",
    "salesPrompt": "Prompt comercial",
    "promptHelp": "Déjelo en blanco para usar el prompt predeterminado del sistema.",
    "questions": "Preguntas de calificación, una por línea",
    "tags": "Etiquetas automáticas, una por línea",
    "transferHuman": "Transferir a humano",
    "createOpportunity": "Crear oportunidad",
    "validConfig": "Configuración válida",
    "cancel": "Cancelar",
    "save": "Guardar",
    "edit": "Editar",
    "remove": "Eliminar",
    "empty": "No se encontraron configuraciones.",
    "removeTitle": "¿Eliminar configuración?",
    "removeNamed": "¿Eliminar la configuración {{name}}?",
    "removeHelp": "Esta acción no elimina sesiones ya registradas, solo la configuración del agente.",
    "updated": "Configuración actualizada correctamente.",
    "created": "Configuración creada correctamente.",
    "enabled": "Agente IA Comercial activado.",
    "disabled": "Agente IA Comercial desactivado.",
    "removed": "Configuración eliminada correctamente."
  },
  "connections": {
    "transferTickets": "Transferir Tickets",
    "transferTitle": "Transferencia de Tickets",
    "transferHelp": "Seleccione las conexiones de origen y destino. Todas las atenciones activas serán transferidas.",
    "source": "Origen",
    "destination": "Destino",
    "confirmTransfer": "Sí, transferir",
    "metaSetup": "Configure Meta en el sistema",
    "officialMeta": "Coexistencia",
    "connectingFacebook": "Conectando Facebook...",
    "loadingFacebook": "Cargando Facebook...",
    "connectingInstagram": "Conectando Instagram...",
    "loadingInstagram": "Cargando Instagram...",
    "receiveComments": "Recibir comentarios",
    "sent": "ENVIADAS",
    "received": "RECIBIDAS",
    "dailyLimit": "Límite diario",
    "messagesDay": "msg/día",
    "status": {
      "CONNECTED": "CONECTADO",
      "DISCONNECTED": "DESCONECTADO",
      "OPENING": "CONECTANDO",
      "PENDING": "PENDIENTE",
      "TIMEOUT": "TIEMPO AGOTADO",
      "PAIRING": "EMPAREJANDO"
    },
    "pairingCode": "Conectado mediante Código de Emparejamiento",
    "qrCode": "Conectado mediante Código QR"
  },
  "modal": {
    "chatbot": "Chatbot",
    "defaultFlow": "Flujo Predeterminado",
    "telegramConfig": "Configuración de Telegram",
    "personalProfile": "Perfil personal",
    "personalHelp": "usa API ID, API Hash y teléfono. La cuenta recibe un código en la app de Telegram. No usa BotFather, token ni webhook. Funciona como una sesión conectada, similar a WhatsApp Web. Acceda:",
    "botHelp": "cree un bot en @BotFather, copie el token y péguelo abajo. El sistema registra el webhook automáticamente.",
    "telegramType": "Tipo de conexión Telegram",
    "generatedAtTelegram": "Generado en my.telegram.org",
    "generatedWithApi": "Generado junto con el API ID",
    "phoneCountry": "Teléfono con código de país",
    "receivedCode": "Código recibido",
    "twoFactor": "Contraseña 2FA, si tiene",
    "sendCode": "Enviar código",
    "confirm": "Confirmar",
    "botToken": "Token del Bot de Telegram",
    "botTokenHelp": "Pegue aquí el token generado en @BotFather. El webhook se configurará automáticamente.",
    "importHistory": "Importar historial al conectar",
    "importDays": "Días para importar",
    "maxDays": "Máximo permitido: 30 días",
    "sessionTitle": "Sesión de WhatsApp",
    "sessionHelp": "Use esta opción cuando la conexión quede bloqueada en \"Conectando\" u \"Opening\". Desconecta solo la sesión actual para permitir generar un nuevo código QR sin crear otra conexión.",
    "sessionHistory": "El historial permanece vinculado a la conexión actual siempre que el backend solo limpie la sesión/auth y no elimine la conexión.",
    "disconnectSession": "Desconectar sesión"
  }
},
      templatesMeta: getTemplatesMetaTranslations("es"),
      operations: getOperationsTranslations("es"),
      taskCleanup: {
        cleanResolved: "Limpiar tareas resueltas",
        tasks: "Tareas",
        allResolved: "Todas las resueltas",
        allCompleted: "Todas las completadas",
        allRejected: "Todas las rechazadas",
        delete: "Eliminar",
        deleting: "Eliminando...",
        confirmAll: "todas las tareas completadas y rechazadas",
        confirmCompleted: "todas las tareas completadas",
        confirmRejected: "todas las tareas rechazadas",
        confirmQuestion: "¿Realmente desea eliminar {{items}}?",
        permanentWarning: "Esta acción es permanente y no se puede deshacer.",
        noneFound: "No se encontraron tareas en esta categoría.",
        oneDeleted: "1 tarea eliminada correctamente.",
        manyDeleted: "{{count}} tareas eliminadas correctamente.",
        deleteError: "No fue posible eliminar las tareas resueltas.",
        team: "Equipo",
        pending: "Pendientes",
        today: "Hoy",
        overdue: "Atrasadas",
        withoutDeadline: "Sin fecha límite",
      },
      marketing: getMarketingTranslations("es"),
      automation: getAutomationTranslations("es"),
      analytics: getAnalyticsTranslations("es"),
      i18nFix: {
        flowExportZip: "Exportar (.zip)",
        flowOpen: "Abrir flujo",
        flowEdit: "Editar flujo",
        flowDelete: "Eliminar flujo",
        flowDeleted: "Flujo eliminado correctamente",
        flowDuplicated: "Flujo duplicado correctamente",
        flowDeleteNamed: '¿Eliminar el flujo "{{name}}"?',
        kanbanStage: "Etapa Kanban", selectKanbanStage: "Seleccione una etapa Kanban",
        contactImportExport: "Exportar / Importar contactos", kanban: "Kanban",
        queueDeleted: "¡Cola eliminada correctamente!", selectRotationType: "Seleccione el tipo de rotación",
        deleteNestedOptions: "¿Está seguro? También se eliminarán todas las opciones internas",
        facebookConnectionSuccess: "¡Facebook conectado correctamente!", contactListSaved: "¡Lista de contactos guardada correctamente!",
        createdAt: "Creado el", updatedAt: "Actualizado el", to: "Hasta", getUsersError: "Error al cargar los usuarios",
        loading: "Cargando...", messageSaved: "¡Mensaje guardado correctamente!", addMessage: "Agregar mensaje", editMessage: "Editar mensaje",
        integrationDeleted: "¡Integración eliminada correctamente!", category: "Categoría", language: "Idioma", metaId: "ID de Meta", status: "Estado",
        quickMessageDeleted: "¡Respuesta rápida eliminada correctamente!", scheduleDeleteTitle: "Eliminar programación",
        scheduleDeleteMessage: "¿Está seguro de que desea eliminar esta programación?", scheduleDeleted: "¡Programación eliminada correctamente!",
        invalidPhoneFormat: "Formato de teléfono inválido", integrationTriggered: "¡Integración activada correctamente!", keyword: "Palabra clave",
        connectionTitle: "Conexión", webhookSaved: "¡Webhook guardado correctamente!", addWebhook: "Agregar webhook",
        editWebhook: "Editar webhook", webhookUpdated: "¡Webhook actualizado correctamente!",
      },
      ticketInfo: {
        copyPhone: "Copiar teléfono",
        quickMessages: "Respuestas rápidas",
        phonecopied: "¡Teléfono copiado al portapapeles!",
        noPhone: "No hay teléfono disponible para copiar",
        copyError: "Error al copiar el teléfono",
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          disabled:
            "El registro de usuarios está deshabilitado en este momento. Por favor, inténtalo más tarde.",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets esperando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
        },
      },
      reports: {
        title: "Informe de encuestas realizadas",
        searchPlaceholder: "Buscar...",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Encuestas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Error al generar el informe",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Informe de encuestas realizadas",
          activeSearch: "Encuesta activa",
          inactiveSearch: "Encuesta inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        newConnection: "Nueva Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          color: "Color",
          receiveComments: "Recibir Comentarios",
        },
        receiveComments: {
          enabled: "Recepción de comentarios habilitada",
          disabled: "Recepción de comentarios deshabilitada",
          tooltip: {
            enabled: "Los comentarios se están recibiendo. Haga clic para deshabilitar.",
            disabled: "Los comentarios no se están recibiendo. Haga clic para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
          redirect: "- redirigió",
          clientClosed: "El cliente cerró el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          prompt: "Prompt",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activadore Integración",
          maxUseInactiveTime:
            "Enviar el flujo de inactividad un máximo de X veces",
          timeToReturnQueue: "Tiempo para volver a la cola, en minutos",
          timeAwaitActiveFlow:
            "Tiempo de espera para activar el flujo",
          flowInactiveTime:
            "Tiempo, en minutos, para enviar el flujo de inactividad",
          collectiveVacationEnd: "Fecha de finalización",
          collectiveVacationStart: "Fecha de inicio",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Cola para importar los mensajes",
          isOficial: "Oficial",
          phone_number_id: "ID del número de teléfono",
          waba_id: "ID de WABA",
          send_token: "Token de envío",
          business_id: "ID del negocio",
          phone_number: "Número de teléfono",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
        errorRatingMessage:
          "Debe ingresar un mensaje de evaluación cuando utilice NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        emptyTitle: "No se encontraron contactos",
        emptyDescription: "Ajusta los filtros o agrega un nuevo contacto para comenzar.",
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversación fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        loading: "Cargando...",
        loadMore: "Cargar Más",
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
          wallet: "Cartera",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
          whatsapp: "Conexión de origen:",
          assignWallet: "Cartera del cliente",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Carteras de contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar cartera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la cartera?",
        notFound: "No se encontró la cartera.",
        deleteSuccess: "¡Contacto eliminado de la cartera correctamente!",
        updateSuccess: "¡Cartera actualizada correctamente!",
        wallet: "Cartera",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          typeRandomMode: "Tipo de rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
          randomizeImmediate: "Aleatorizar automáticamente (inmediato)",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Eliminar imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendientes",
          showReturnQueueButton: "Mostrar botón de devolver a la fila",
          showTransferTicketButton: "Mostrar botón de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel en Tiempo Real",
          allowConnections: "Permitir acciones en conexiones",
          showContacts: "Ver contactos",
          showCampaign: "Ver campañas",
          showFlow: "Ver automatizaciones",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar programa",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en minutos para redirigir al carril",
          nextLaneId: "Carril",
          greetingMessageLane: "Mensaje de bienvenida del carril",
          mediaFiles: "Medios",
          rollbackLaneId: "Volver al carril después de reanudar la atención",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          fileOptions: "Lista de archivos",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          resolveAll: "Resolver todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensaje oculto",
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
          messageHidden: "Mensaje oculto",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opciones de Kanban",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          birthdaySettings: "Config. Cumpleaños",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Admin conexiones",
          reports: "Informes",
          management: "Gerencia",
          callHistorical: "Historial de Llamadas",
          automations: "Automatizaciones",
          files: "Lista de archivos",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        ar: "Árabe",
        "pt-BR": "Portugués",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        extended: {
          documentationTitle: "Documentación para envío de mensajes", methodsTitle: "Métodos de envío", new: "NUEVO",
          mediaMessages: "Mensajes multimedia", checkNumber: "Verificar número", noTicket: "Envío sin ticket", imageUrl: "Imagen por URL", bulk: "Envío por lotes", listConnections: "Listar conexiones", interactiveButtons: "Mensaje con botones", mixedButtons: "Botones mixtos (quick_reply + URL)",
          tokenInstruction: "Antes de enviar mensajes, registre el token vinculado a la conexión de envío. Abra Conexiones, edite la conexión e informe el token.", numberInstruction: "El número debe contener solo Código de país + Código de área + Número, sin máscara ni caracteres especiales (ej.: 5511999998888).", headerInstruction: "Todos los endpoints requieren el header:",
          testSend: "Prueba de envío", textTitle: "Mensajes de texto", textDescription: "Envía un mensaje de texto y registra un ticket.", mediaDescription: "Envía archivos (imagen, audio, vídeo o documento).", checkTitle: "Verificar número de WhatsApp", checkDescription: "Comprueba si un número tiene WhatsApp activo antes del envío.", noTicketTitle: "Envío sin ticket (envío rápido)", noTicketDescription: "Envía un mensaje directamente sin crear ni registrar un ticket. Ideal para notificaciones rápidas.", imageTitle: "Envío de imagen por URL", imageDescription: "Envía una imagen desde una URL pública sin cargar un archivo.", bulkTitle: "Envío por lotes", bulkDescription: "Envía mensajes a varios números en una sola solicitud. Límite: 100 mensajes por lote.", connectionsTitle: "Listar conexiones disponibles", connectionsDescription: "Devuelve las conexiones activas de WhatsApp de la empresa y sus IDs.", buttonsTitle: "Mensaje con botones interactivos", buttonsDescription: "Envía un mensaje interactivo con hasta 3 botones. También admite listas, URLs y PIX.", mixedTitle: "Botones mixtos (quick_reply + URL + copy + call)", mixedDescription: "Envía un mensaje con diferentes tipos de botón. Límite de 5 botones.",
          bodyJson: "Body JSON:", response: "Respuesta:", registeredToken: "Token registrado *", number: "Número *", message: "Mensaje *", userId: "ID del usuario/agente", queueId: "ID de la fila", caption: "Leyenda (opcional)", imageAddress: "URL de la imagen *", messagesJson: "JSON de los mensajes *", buttonsJson: "JSON de los botones *", mixedButtonsJson: "JSON de botones mixtos *", footer: "Pie de página", send: "Enviar", verify: "Verificar", sendBatch: "Enviar lote", sendButtons: "Enviar botones", sendMixed: "Enviar mixtos", list: "Listar conexiones", invalidJson: "JSON no válido.", success: "Operación realizada correctamente.",
          accessDenied: "Esta empresa no tiene permiso para acceder a esta página.", headersJson: "Headers: Authorization Bearer (token) y Content-Type (application/json)", headersForm: "Headers: Authorization Bearer y Content-Type (multipart/form-data)", formData: "FormData:", optionalCaption: "Leyenda (opcional)", userIdHelp: "ID del usuario o vacío", queueIdHelp: "ID de la fila o vacío", file: "archivo", delayHelp: "delay: intervalo en ms entre envíos (predeterminado: 2000)", bodyButtons: "Body JSON (Botones):", bodyList: "Body JSON (Lista):", queueClick: "queueId: dirige el ticket a la fila al hacer clic", userClick: "userId: asigna el ticket a un agente específico", maxButtons: "Máx. 3 botones (5 en mixed)", quickReplyHelp: "quick_reply: botón de respuesta rápida (con id)", urlHelp: "cta_url: abre un enlace externo", copyHelp: "cta_copy: copia texto (ej.: PIX)", callHelp: "cta_call: inicia una llamada", maxMixed: "Máx. 5 botones"
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      birthday: {
        defaultUserMessage: "🎉 ¡Feliz cumpleaños, {nome}! ¡Hoy es tu día especial! Te deseamos mucho éxito y felicidad.", defaultContactMessage: "🎉 ¡Feliz cumpleaños, {nome}! Te deseamos mucho éxito, salud y felicidad. ✨",
        title: "Configuración de cumpleaños", loading: "Cargando configuración...", users: "Cumpleaños de usuarios", contacts: "Cumpleaños de contactos", general: "Configuración general", selectConnection: "Seleccione una conexión", saving: "Guardando...",
        enableUsers: "Habilitar notificaciones de cumpleaños de usuarios", enableUsersHelp: "Muestra el diálogo de felicitación y crea un aviso automático.", createUserNotice: "Crear aviso automático para cumpleaños de usuarios", createUserNoticeHelp: "Crea un aviso visible para todos los usuarios de la empresa.", userMessage: "Mensaje de cumpleaños para usuarios", userMessageHelp: "Use {nome} para incluir el nombre del usuario.",
        enableContacts: "Enviar mensajes automáticamente a contactos que cumplen años", enableContactsHelp: "Envía automáticamente un mensaje de felicitación por WhatsApp.", contactMessage: "Mensaje de cumpleaños para contactos", contactMessageHelp: "Use {nome} para el nombre y {idade} para la edad.", preview: "Vista previa:", test: "Probar mensaje", sendTime: "Hora de envío de los mensajes", sendTimeHelp: "Hora en que se enviarán los mensajes automáticos.", connection: "Conexión de WhatsApp para el envío", connectionHelp: "Conexión utilizada para enviar los mensajes de cumpleaños.", internalNotice: "Crear aviso interno para cumpleaños de usuarios", internalNoticeHelp: "Crea un aviso interno cuando un usuario cumple años.", variables: "Variables disponibles en los mensajes:", personName: "Nombre de la persona", personAge: "Edad de la persona (solo contactos)", save: "Guardar configuración",
        loadError: "Error al cargar la configuración de cumpleaños.", saveSuccess: "¡Configuración de cumpleaños guardada correctamente! 🎉", saveError: "Error al guardar la configuración.", promptContact: "Ingrese el ID de un contacto para la prueba:", testSuccess: "¡Mensaje de prueba enviado! 📱", testError: "Error al enviar el mensaje de prueba.", congratulations: "¡Feliz cumpleaños!", specialDay: "¡Hoy es un día especial!", loadingPeople: "Cargando cumpleaños...", systemUser: "Usuario del sistema", alreadySent: "Mensaje ya enviado", sendCongratulations: "Enviar felicitación", sentTo: "¡Felicitación enviada a {{name}}! 🎉", alreadySentToast: "El mensaje de cumpleaños ya fue enviado hoy a este contacto.", sendError: "Error al enviar el mensaje de cumpleaños."
      },
      notifications: {
        noTickets: "Sin notificaciones.",
        messageHidden: "Mensaje oculto",
        newMessage: "Nuevo mensaje de",
      },
      triggerFlowModal: {
        title: "Disparar Flujo",
        description:
          "Selecciona un flujo para ejecutar en este ticket. El ticket cambiará a estado 'chatbot' durante la ejecución.",
        selectFlow: "Elige un flujo",
        selectedFlow: "Flujo seleccionado",
        flowId: "ID del flujo",
        noFlows: "No se encontraron flujos activos",
        cancel: "Cancelar",
        trigger: "Disparar Flujo",
        triggering: "Disparando...",
        success: "¡Flujo disparado con éxito!",
        error: "Error al disparar el flujo",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        selectMessage: "Seleccionar Respuesta Rápida",
        hasMedia: "Con multimedia",
        global: "Global",
        noResultsFound: "No se encontraron respuestas rápidas para tu búsqueda",
        noQuickMessages: "No hay respuestas rápidas disponibles",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listas de contactos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
            pendingTicketStatus: "Pendiente",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
        fetchError: "Error al obtener datos del reporte",
        backButton: "Volver",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          generateInvoice: "Generar factura",
          money: "MXN",
          currency: "Moneda",
          brl: "BRL — Real brasileño",
          cop: "COP — Peso colombiano",
          usd: "USD — Dólar estadounidense",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Toda la información de la empresa será eliminada. Los tickets abiertos de este usuario se moverán a la cola.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programaciones",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
          currency: "Moneda",
          brl: "BRL — Real brasileño",
          cop: "COP — Peso colombiano",
          usd: "USD — Dólar estadounidense",
          public: "Público",
          trial: "Prueba",
          trialDays: "Días de Prueba",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programaciones",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Está seguro de que desea eliminar esta programación?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha programada",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva programación",
        },
        toasts: {
          deleted: "Programación eliminada correctamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
            transferredTicketStatus:
              "Estado del ticket al transferir con usuario",
            copyContactPrefix: "Prefijo para Copia de Contactos",
            copyContactPrefixPlaceholder: "Ej: COPIA_",
            open: "Abierto",
            pending: "Pendiente",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          amount: "Valor de prospección",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar integración",
            disableIntegration: "Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
            greetingAcceptedMessage:
              "Debes configurar un mensaje de saludo al aceptar el ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
          scheduledDate: "Fecha del Programa",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
          triggerFlow: "Disparar Flujo",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
          template: "Plantilla Meta",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrencia",
        description:
          "Puede enviar el mensaje de forma recurrente y seleccionar el intervalo. Si es un envío único, no cambie nada en esta sección.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        chooseAStream: "Elige una transmisión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
        deleteMessage: "¿Está seguro de que desea eliminar este mensaje?",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Nombre del grupo",
          create: "Crear",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
    },
  },
};

export { messages };
